/*import Vue from 'vue'*/
import EventUtils from '@/utils/EventUtils.js';
import MapUtils from '@/utils/MapUtils.js';
import ConstUtils from '@/utils/ConstUtils.js';

const state = {
  list: [],
  map: {},
};

const getters = {
    AiPromptStorage: state => state,
};

const actions = {
};

const mutations = {
  SOCKET_ONMESSAGE (state, event)  {
    if (event.status == EventUtils.STATUS.COMPLETE && event.statusCode == EventUtils.CODE.OK) {
      if (event.Payload && event.Payload.AiPromptMap) {
        var objMap = event.Payload.AiPromptMap;
        state.map = MapUtils.updateMap(objMap, state.map);
        state.list = Object.values(state.map);
      }
      if (event.Payload && event.Payload.AiPrompt) {
        var obj = event.Payload.AiPrompt;
        state.map[obj[ConstUtils.FIELDS.ID]] = obj;
        state.list = Object.values(state.map);
      }
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
